import { requestAddStudentToEventReservation } from "services/events/attendance";
import useMainContext from "utils/context/useMainContext";
import { ERROR_TEXTS_ADD_STUDENT_RESERVATION } from "../constants";

const useAddStudentReservation = ({
	dialogResultSearchStudent,
	loadingRequest,
	studentToAdd,
	eventData,
	studentReservations,
	setHiddenToastSuccessAddReservation,
}) => {
	const mainContext = useMainContext();
	function errorAdding(message) {
		const errorText = ERROR_TEXTS_ADD_STUDENT_RESERVATION[message] || null;
		if (errorText) 
			mainContext.setDialogUnexpectedErrorMessage(errorText);
		mainContext.setShowDialogUnexpectedError(true);
	}
	async function successAdding() {
		await studentReservations.fill();
		// Mostrando mensaje de alumno agregado con éxito
		studentToAdd.clearStudentId();
		setHiddenToastSuccessAddReservation(false);
		setTimeout(() => {
			setHiddenToastSuccessAddReservation(true);
		}, 2400);
	}
	const addStudentReservation = async () => {
		dialogResultSearchStudent.set(false);
		loadingRequest.show("Agregando alumno...");
		const { success, message } = await requestAddStudentToEventReservation({
			id: studentToAdd.value.id,
			dateEventId: eventData.dateEventId,
		});
		loadingRequest.hide();
		if (success) successAdding();
		else errorAdding(message);
	};
	return addStudentReservation;
};

export default useAddStudentReservation;
